/**
 * Define alert/confirm plugin
 *
 * @author minkyoung.park@emcast.com
 */
import AlertModal from './AlertModal.vue'

const alertPlugin = {
    install(Vue, optiuons) {
        let alertConstructor = Vue.extend(AlertModal)
        let alertInstance = null

        alertInstance = new alertConstructor({
            el: document.createElement('div')
        })

        alertInstance.attachMaterial(alertInstance.$el)
        document.body.appendChild(alertInstance.$el)        

        Vue.prototype.$alert = function (payload) {
            return new Promise((resolve, reject) => {
                alertInstance.open(payload, false).then((data) => {
                    resolve(data)
                }).catch((err) => {
                    reject(err)
                })
            })
        }

        Vue.prototype.$confirm = function (payload) {
            return new Promise((resolve, reject) => {
                alertInstance.open(payload, true).then((data) => {
                    resolve(data)
                }).catch((err) => {
                    reject(err)
                })
            })
        }
        Vue.prototype.$error = Vue.prototype.$alert
        Vue.prototype.$ok = Vue.prototype.$alert
        Vue.prototype.$info = Vue.prototype.$alert
    }
}

export default alertPlugin